import React, { useEffect, useState } from "react";
import GlobalDialog from "../../../../components/mui/Dialogue/GlobalDialog";
import { Box, Button, Stack, TextField } from "@mui/material";
import { useFormik, FormikProvider, Form } from "formik";
import * as Yup from "yup";
import useResponsive from "../../../../Hooks/useResponsive";
import {
  CancelButton,
  SubmitButton,
  UpdateButton,
} from "../../../../components/mui/Buttons/Buttons";
import { useDispatch } from "react-redux";
import { addTargetOrSlot, getTargetOrSlot } from "../../../../redux/features/ogdSlice";
import { useSelector } from "react-redux";
import { getOGMDashboardCounts } from "../../../../redux/features/OgdDashboard";
import { savePaginationData } from "../../../../redux/features/globalDatagridSlice";
import { useSnackbar } from "notistack";
import SimpleLoader from "../../../../components/Loader/SimpleLoader";
import dayjs from "dayjs";

const AddOrUpdateTarget = ({ dispatchParams, rowData }) => {
  const dispatch = useDispatch();
    const { enqueueSnackbar } = useSnackbar();
  const { loading, targetDatas } = useSelector((store) => store.ogd);
  const { paginationData } = useSelector((state) => state.globalDataGrid);
  const [open, setOpen] = useState(false);
  const mdDown = useResponsive("down", "md");
  const [direction, setDirection] = useState("row");
  const [isButtonDisabled,setIsButtonDisabled]=useState(true)
  useEffect(() => {
    const currentDate = dayjs().date(); 
    if (currentDate >= 1 && currentDate <= 5) {
      setIsButtonDisabled(false);
    }
  }, []);
  useEffect(() => {
    if (open && rowData?.userId) {
      dispatch(getTargetOrSlot(rowData?.userId));
    }
  }, [rowData?.userId, open]);

  useEffect(() => {
    if (mdDown) {
      setDirection("column");
    } else {
      setDirection("row");
    }
  }, [mdDown]);
  const initialValues = {
    assigned_to: rowData?.userId,
    target: targetDatas[0]?.target ?? "",
    slot: targetDatas[0]?.slot ?? "",
  };

  const schema = Yup.object({
    target: Yup.number().required("Target Required"),
    slot: Yup.number().required("Slot Required"),
  });

  const formik = useFormik({
    initialValues,
    enableReinitialize: true,
    validationSchema: schema,
    onSubmit: (values) => {
      console.log(values);
      const updateData = {data:[{ ...values }]};
      dispatch(addTargetOrSlot(updateData)).then((res) => {
        if (res.payload.status === "error") {
          enqueueSnackbar(res.payload.message, {
            variant: "error",
          });
        } else if (res.payload.status === "success") {
          handleCancel();
          dispatch(getOGMDashboardCounts(dispatchParams));
          dispatch(
            savePaginationData({ ...paginationData, openAnchor: false })
          );
          enqueueSnackbar(res.payload.message, {
            variant: "success",
          });
        }
      });
    },
  });
  const handleCancel = () => {
    setOpen(false);
    formik.resetForm();
  };

  return (
    <GlobalDialog
      maxWidth={"sm"}
      fullWidth={true}
      title={"Target And Slots"}
      open={open}
      setOpen={setOpen}
      closeButton={true}
      closeCondition={handleCancel}
      popupButton={
        <>
          <Button
          disabled={isButtonDisabled}
            variant="outlined"
            size="small"
            onClick={() => {
              setOpen(true);
            }}
          >
            Target/Slot
          </Button>
        </>
      }
      content={
        <>
        {loading ?<SimpleLoader /> : (
            <FormikProvider value={formik}>
            <Form onSubmit={formik.handleSubmit}>
              <Stack gap={1} direction={direction}>
                <Box>
                  <TextField
                  type="number"
                    disabled={loading}
                    autoComplete="off"
                    fullWidth
                    id="target"
                    label="Target"
                    name="target"
                    value={formik.values.target}
                    onChange={formik.handleChange}
                    error={
                      formik.touched.target && Boolean(formik.errors.target)
                    }
                    helperText={formik.touched.target && formik.errors.target}
                  />
                </Box>
                <Box>
                  <TextField
                  type="number"
                    disabled={loading}
                    autoComplete="off"
                    fullWidth
                    id="slot"
                    label="Slot"
                    name="slot"
                    value={formik.values.slot}
                    onChange={formik.handleChange}
                    error={formik.touched.slot && Boolean(formik.errors.slot)}
                    helperText={formik.touched.slot && formik.errors.slot}
                  />
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "flex-end",
                    alignItems: "center",
                  }}
                >
                  <Stack direction={"row"} spacing={1}>
                    <CancelButton action={() => handleCancel()}>
                      Cancel
                    </CancelButton>
                    {false ? (
                      <UpdateButton disabled={loading} type="submit">
                        {loading ? "Updating..." : "Update"}
                      </UpdateButton>
                    ) : (
                      <SubmitButton disabled={loading} type="submit">
                        {loading ? "Submiting..." : "Submit"}
                      </SubmitButton>
                    )}
                  </Stack>
                </Box>
              </Stack>
            </Form>
          </FormikProvider>
            )}
        
         
        </>
      }
    />
  );
};

export default AddOrUpdateTarget;
